import React from 'react'

const Message = () => {
    return (
        <div className='m-0 p-0 relative'>
            <div className="chat chat-start ">
                <div className="chat-image avatar">
                    <div className="w-10 rounded-full">
                        <img alt="Tailwind CSS chat bubble component" src="https://img.daisyui.com/images/stock/photo-1534528741775-53994a69daeb.jpg" />
                    </div>
                </div>
                <div className="chat-bubble bg-teal-700 text-light text-slate-200 ">You were the Chosen One!</div>
                <div className="chat-footer opacity-80">
                    Delivered
                    <time className="text-xs mx-2 opacity-50">12:45</time>
                </div>
            </div>
            <div className="chat chat-end">
                <div className="chat-image avatar">
                    <div className="w-10 rounded-full">
                        <img alt="Tailwind CSS chat bubble component" src="https://img.daisyui.com/images/stock/photo-1534528741775-53994a69daeb.jpg" />
                    </div>
                </div>
                <div className="chat-bubble  bg-teal-300 bg-opacity-10 text-light text-slate-200 ">I hate you!</div>
                <div className="chat-footer opacity-80 p-0">
                    Seen at 12:46
                </div>
            </div>
        </div>

        // <>
        //     <div className='flex gap-3 items-center'>
        //         <div className='skeleton w-10 h-10 rounded-full shrink-0'></div>
        //         <div className='flex flex-col gap-1'>
        //             <div className='skeleton h-4 w-40'></div>
        //             <div className='skeleton h-4 w-40'></div>
        //         </div>
        //     </div>
        //     <div className='flex gap-3 items-center justify-end'>
        //         <div className='flex flex-col gap-1'>
        //             <div className='skeleton h-4 w-40'></div>
        //         </div>
        //         <div className='skeleton w-10 h-10 rounded-full shrink-0'></div>
        //     </div>
        // </>
    )
}

export default Message